import { Message } from 'queries/events/records/contract';
import React, { useContext } from 'react';
import { dateTime } from 'utils';
import { AppContext } from 'appContext';
import { t } from 'i18next';
import {
  Scope,
  RecordCategoryType,
  RecordCategory,
  GenericCategory,
} from 'queries/events/records/types';
import RecordsMessageContent from './RecordsMessageContent';
import { formatUserName } from '../utils';

export interface RecordMessagesItemProps {
  message: string;
  timestamp: string;
  author: string;
}

const getTitleByCategory = ({
  category,
  user_email,
  scope,
}: {
  scope?: Scope;
  category: RecordCategoryType;
  user_email: string;
}) => {
  if (category === RecordCategory.COMMENT) return formatUserName(user_email);
  const messageScope = Object.values(GenericCategory).includes(category as GenericCategory)
    ? Scope.GENERIC
    : scope;

  return t(`records:category.${messageScope}.${category}`);
};
const RecordMessageItem: React.FC<{ message: Message; scope?: Scope }> = ({ message, scope }) => {
  const { state } = useContext(AppContext);
  const userEmailClass = message.user_email === state.auth.user?.email ? 'records-item-self' : '';
  const temporaryMsgClass = message.id === '' ? 'temporary' : '';

  return (
    <div className="records-outer-item">
      <div
        data-testid="record-item"
        className={`records-item ${userEmailClass} ${temporaryMsgClass}`}
      >
        <div className="records-header">
          <div className="records-title">
            {getTitleByCategory({
              scope,
              category: message.category,
              user_email: message.user_email,
            })}
          </div>
          <div className="records-date">{dateTime(message.date)}</div>
        </div>
        <RecordsMessageContent message={message} scope={scope} />
      </div>
    </div>
  );
};

export default RecordMessageItem;
